import { NetworkUserStatus } from '@shared/enums/networkUserStatus.enum';
import { setNetworkSelectUserInfo } from '@store/network/networkSlice';
import { getGlobalUser } from '@store/network/networkThunk';

import type { AppDispatch } from '@store/store';

type GetUserInfoProps = {
  dispatch: AppDispatch;
  userId: number;
};

export const getUserInfo = ({ dispatch, userId }: GetUserInfoProps) => {
  dispatch(getGlobalUser({ id: userId })).then((result) => {
    if (getGlobalUser.fulfilled.match(result)) {
      dispatch(
        setNetworkSelectUserInfo({
          data: {
            ...result.payload,
            entity_type:
              result.payload.entity_type === null ? NetworkUserStatus.incoming : result.payload.entity_type,
          },
        }),
      );
    }
  });
};
